"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/*
  The MIT License
  
  Copyright (c) 2017-2019 EclipseSource Munich
  https://github.com/eclipsesource/jsonforms
  
  Permission is hereby granted, free of charge, to any person obtaining a copy
  of this software and associated documentation files (the "Software"), to deal
  in the Software without restriction, including without limitation the rights
  to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
  copies of the Software, and to permit persons to whom the Software is
  furnished to do so, subject to the following conditions:
  
  The above copyright notice and this permission notice shall be included in
  all copies or substantial portions of the Software.
  
  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
  IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
  FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
  AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
  LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
  OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
  THE SOFTWARE.
*/
var react_1 = tslib_1.__importDefault(require("react"));
var core_1 = require("@jsonforms/core");
var core_2 = require("@material-ui/core");
var react_2 = require("@jsonforms/react");
var TextField_1 = tslib_1.__importDefault(require("@material-ui/core/TextField"));
var merge_1 = tslib_1.__importDefault(require("lodash/merge"));
var MaterialNativeControl = /** @class */ (function (_super) {
    tslib_1.__extends(MaterialNativeControl, _super);
    function MaterialNativeControl() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MaterialNativeControl.prototype.render = function () {
        var _a;
        var _b = this.props, id = _b.id, errors = _b.errors, label = _b.label, schema = _b.schema, description = _b.description, enabled = _b.enabled, visible = _b.visible, required = _b.required, path = _b.path, handleChange = _b.handleChange, data = _b.data, config = _b.config;
        var isValid = errors.length === 0;
        var appliedUiSchemaOptions = merge_1.default({}, config, this.props.uischema.options);
        var onChange = function (ev) { return handleChange(path, ev.target.value); };
        var fieldType = (_a = appliedUiSchemaOptions.format) !== null && _a !== void 0 ? _a : schema.format;
        var showDescription = !core_1.isDescriptionHidden(visible, description, this.state.isFocused, appliedUiSchemaOptions.showUnfocusedDescription);
        return (react_1.default.createElement(core_2.Hidden, { xsUp: !visible },
            react_1.default.createElement(TextField_1.default, { id: id + '-input', label: core_1.computeLabel(label, required, appliedUiSchemaOptions.hideRequiredAsterisk), type: fieldType, error: !isValid, disabled: !enabled, fullWidth: !appliedUiSchemaOptions.trim, onFocus: this.onFocus, onBlur: this.onBlur, helperText: !isValid ? errors : showDescription ? description : null, InputLabelProps: { shrink: true }, value: data, onChange: onChange })));
    };
    return MaterialNativeControl;
}(react_2.Control));
exports.MaterialNativeControl = MaterialNativeControl;
exports.materialNativeControlTester = core_1.rankWith(2, core_1.or(core_1.isDateControl, core_1.isTimeControl));
exports.default = react_2.withJsonFormsControlProps(MaterialNativeControl);
//# sourceMappingURL=MaterialNativeControl.js.map